import { render, staticRenderFns } from "./NoPjaxButton.vue?vue&type=template&id=21a11e60"
import script from "./NoPjaxButton.vue?vue&type=script&lang=js"
export * from "./NoPjaxButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports